/*
 * Generic browser stub for server-only packages (openai, axios, @aws-sdk/*).
 *
 * WEB's browser code never imports or uses these at runtime (uploads go through a presigned-URL
 * flow, not the S3 client). They are pulled into the bundle only transitively, because web imports
 * api/src DTOs/entities/utils that live alongside server code referencing these SDKs. Mapping the
 * packages here keeps the real (large) implementations out of the browser bundle.
 *
 * Every property access, call and construct resolves to the same harmless no-op proxy, so even
 * never-executed top-level SDK usage in imported server code (e.g. `new S3Client()`,
 * `axios.create()`) cannot throw at module-evaluation time.
 */

const handler = {
	get: function (target, prop) {
		if (prop === '__esModule') return true;
		if (prop === 'default') return proxy;
		if (typeof prop === 'symbol') return undefined;
		return proxy;
	},
	apply: function () {
		return proxy;
	},
	construct: function () {
		return proxy;
	}
};

const proxy = new Proxy(function () {}, handler);

module.exports = proxy;
